import { Link } from 'react-router-dom';
import { formatDisplayDate } from '@/utils/storage';

const YMD_RE = /\b(\d{4}-\d{2}-\d{2})\b/g;

const isPlausibleJournalYmd = (ymd) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(ymd);
  if (!m) return false;
  const y = Number(m[1]);
  const mo = Number(m[2]);
  const d = Number(m[3]);
  const dt = new Date(y, mo - 1, d);
  return dt.getFullYear() === y && dt.getMonth() === mo - 1 && dt.getDate() === d;
};

/**
 * Split coach reply text so calendar entry keys (YYYY-MM-DD) can render as day links.
 */
export const splitCoachTextWithJournalDayLinks = (raw) => {
  const text = String(raw ?? '');
  const out = [];
  let last = 0;
  let match;
  const re = new RegExp(YMD_RE.source, 'g');
  while ((match = re.exec(text)) !== null) {
    if (match.index > last) out.push({ kind: 'text', text: text.slice(last, match.index) });
    const ymd = match[1];
    if (isPlausibleJournalYmd(ymd)) out.push({ kind: 'day', ymd });
    else out.push({ kind: 'text', text: match[0] });
    last = match.index + match[0].length;
  }
  if (last < text.length) out.push({ kind: 'text', text: text.slice(last) });
  if (out.length === 0) out.push({ kind: 'text', text });
  return out;
};

export const CoachJournalDayMessage = ({ text, className }) => {
  const parts = splitCoachTextWithJournalDayLinks(text);
  return (
    <span className={className}>
      {parts.map((p, i) =>
        p.kind === 'text' ? (
          <span key={i}>{p.text}</span>
        ) : (
          <Link
            key={i}
            to={`/historical-view/${p.ymd}`}
            className="inline underline decoration-wisteria-400/80 underline-offset-2 font-medium text-wisteria-700 hover:text-wisteria-900 focus:outline-none focus:ring-2 focus:ring-wisteria-200 rounded-sm"
          >
            {formatDisplayDate(p.ymd)}
          </Link>
        ))}
    </span>
  );
};
